const typeBenefits = [
  {
    id: "ANNUAL",
    title: "Annual Leave",
  },
  {
    id: "INSURANCE",
    title: "Insurance Leave",
  },
  {
    id: "UNPAID",
    title: "Unpaid Leave",
  },
  {
    id: "PRIVATE",
    title: "Private Leave With Paid",
  },
];

export { typeBenefits };
